module.exports = __webpack_public_path__ + "static/media/truck-orange.f3ff7d66.svg";